module.exports = __webpack_public_path__ + "img/bi.09d7af21.svg";